// Russian

export default {

  component: {
    jobAdList: {
      title: 'Открытые вакансии',
      jobs: 'Позиции',
      noJobAds: 'В настоящее время вакансии отсутствуют.',
    },

    jobAdCard: {
      openUntil: date => `Крайний срок подачи анкет ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Спасибо.',
      readyInfo: 'Мы получили ваше заявление. Специалист по найму кадров свяжется с вами в ближайшее время.',
      luck: 'Желаем удачи!',
    },

    jobAdSeeYou: {
      title: 'Спасибо.',
      description: 'Ваша анкета сохранена, мы отправили Вам ссылку для продолжения заполнения анкеты позже.',
    },

    unpublished: {
      title: 'Не опубликовано',
      info: 'Объявление о работе ещё не опубликовано',
    },
  },

  page: {},

}
